/* eslint-disable jsx-a11y/label-has-associated-control */
import { Time } from '@carbon/icons-react';
import { Toggle } from '@carbon/react';
import { defineMessages, useIntl } from 'react-intl';

import styles from './EventAllDayToggle.module.scss';

import { useEventContext } from 'Screens/Dashboard/Events/EventHandler/EntityEventContext';

const EventAllDayToggle = () => {
    const intl = useIntl();

    const { values, updateValues } = useEventContext();
    const { allDay } = values;

    const updateAllDay = () => {
        updateValues({
            allDay: !allDay,
        });
    };

    return (
        <div className={styles.container}>
            <label
                form="event-handler-form"
                id="event-all-day-toggle-label"
                htmlFor="event-all-day-toggle"
                className={styles.label}
            >
                <Time />
                <span>{intl.formatMessage(messages.allDay)}</span>
            </label>
            <Toggle
                form="event-handler-form"
                aria-labelledby="event-all-day-toggle-label"
                onToggle={updateAllDay}
                toggled={allDay}
                labelA=""
                labelB=""
                id="event-all-day-toggle"
            />
        </div>
    );
};

const messages = defineMessages({
    allDay: {
        id: 'src.Screens.Dashboard.Events.EventHandler.inputs.EventAllDayToggle.EventAllDayToggle.allDay',
        defaultMessage: 'Cały dzień',
    },
});

export default EventAllDayToggle;
